import React from 'react';
import type {Recruitment} from '../../../../../core/repositories/recruitingInfoRepository';
import {CardForPc} from '../../../../recruitingInfo/components/Container/Presenter/CardForPc';
import {CardForSp} from '../../../../recruitingInfo/components/Container/Presenter/CardForSp';

type Props = {
  recruitmentList: Recruitment[];
};

export const CompanyPageRecruitmentList: React.FC<Props> = ({
  recruitmentList,
}: Props) => {
  return (
    <div className="grid grid-cols-1 pc:py-16 pc:grid-cols-2 gap-16">
      {recruitmentList.map((recruitment) => (
        <React.Fragment key={recruitment.id}>
          <div key={`pc-${recruitment.id}`} className="hidden pc:inline-block">
            <CardForPc recruitment={recruitment} />
          </div>
          <div key={`sp-${recruitment.id}`} className="pc:hidden">
            <CardForSp recruitment={recruitment} />
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
